import React, { Component } from 'react';
import PropTypes from 'prop-types';
import store from '../src/store'
import './App.css';
import { LayoutRoute, LaunchLayout, MainLayout, Layout } from '../src/layouts';
import { BrowserRouter, Redirect, Switch, withRouter } from 'react-router-dom';
import Home from "../src/components/Home";
import Library from "../src/components/Library";
import FLLTeam from "../src/components/FLLTeam";
import MainHome from "../src/components/MainHome";
import Team from "../src/components/Team";
import User from "../src/components/User";
import ClassView from "../src/components/ClassView"
import { library } from '@fortawesome/fontawesome-svg-core';
import { authenticate, unauthenticate } from '../src/actions/SessionAction'

import {
	faUsers,faHome,faCalendar,faBuilding,faPencilAlt,faPhone,faEnvelope,faAddressBook,
	faLink,faCheckCircle,faUserPlus,faUser,faClock, faChalkboardTeacher
} from '@fortawesome/free-solid-svg-icons';
import MyLibraries from './components/MyLibraries';
import ChangePassword from "../src/components/ChangePassword"

library.add(faUsers);
library.add(faHome);
library.add(faCalendar);
library.add(faBuilding);
library.add(faPencilAlt);
library.add(faPhone);
library.add(faEnvelope);
library.add(faAddressBook);
library.add(faLink);
library.add(faCheckCircle);
library.add(faUserPlus);
library.add(faUser);
library.add(faClock);
library.add(faChalkboardTeacher);


const RouterContextProvider = withRouter(
	class extends React.Component {
	  static childContextTypes = {
		router: PropTypes.object
	  };
  
	  getChildContext() {
		const { children, ...router } = this.props;
		return { router };
	  }
  
	  render() {
		return this.props.children;
	  }
	}
  );

class App extends Component {
	componentDidMount() {
		const token = localStorage.getItem('token');
		if (token !== null) {
			store.dispatch(authenticate())
		} else {
			store.dispatch(unauthenticate())
		}
		
	}
	render() {
		return (
			<BrowserRouter>
			  <RouterContextProvider>
				<Switch>
					<LayoutRoute
						exact
						path="/"
						layout={LaunchLayout}
						component={Home}
					/>
					<LayoutRoute
						exact
						path="/alllibraries"
						layout={LaunchLayout}
						component={Library}
					/>

					<LayoutRoute
						exact
						path="/fllteams"
						layout={LaunchLayout}
						component={FLLTeam}
					/>

				  <LayoutRoute
						exact
						path="/home"
						layout={MainLayout}
						component={MainHome}
					/>
					<LayoutRoute
						exact
						path="/libraries"
						layout={MainLayout}
						component={MyLibraries}
					/>
					<LayoutRoute
						exact
						path="/teams"
						layout={MainLayout}
						component={Team}
					/>
					<LayoutRoute
						exact
						path="/users"
						layout={MainLayout}
						component={User}
					/>
        	<LayoutRoute
						exact						
						path="/classView/:id"
						layout={MainLayout}
						component={ClassView}
					/>	
					<LayoutRoute
						exact						
						path="/verify/:token"
						layout={Layout}
						component={ChangePassword}
					/>			
					<Redirect to="/" />
				</Switch>
			  </RouterContextProvider>
			</BrowserRouter>
		);
	}
}

export default App;
